module.exports = __webpack_public_path__ + "img/form-gps.87492760.svg";